import angular from "angular"

export default function wrapVueComponent(name, component) {
  // Name should be CamelCased

  // Register VueComponent as a value in the app
  // Future: accept the app/module as parameter
  angular.module("appModule").value(name, component)

  // Wraper name is `wrap` before the component name
  const wrapperName = `wrap${name}`

  const wrapper = {
    template: `
      <vue-component name="${name}" v-on-hello="$ctrl.handleGo" v-props="$ctrl.props"/>
    `,
    controller: [
      "$state",
      "$stateParams",
      "store",
      function($state, $stateParams, store) {
        // Define the props
        this.props = $stateParams

        // Inject current user data
        const user = store.get("user")
        this.props["user"] = user

        // Define the navigation handler
        this.handleGo = function(route) {
          const state = route.state || route
          const params = route.params || {}

          console.log(`Handling navigation to: ${state}`)
          $state.go(state, params)
        }
      }
    ]
  }

  // Register the wrapper in the app (and return the name given)
  return angular.module("appModule").component(wrapperName, wrapper).name
}
